import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#475816] shadow-md py-2" : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 flex items-center justify-between">
        {/* Logo */}
        <button onClick={() => scrollTo("hero")} className="cursor-pointer">
          <img
            src="https://static.readdy.ai/image/2500ac09d0252d19a03ba42d5ab6c3f1/468be9c5d41a510624ef7875614aef05.svg"
            alt="Festa della Tammorra Logo"
            className="h-12 w-auto object-contain"
          />
        </button>

        {/* Desktop menu */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: "Lineup", id: "lineup" },
            { label: "Location", id: "location" },
            { label: "Richiesta Stand", id: "richiesta-stand" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="font-['Londrina_Solid'] text-white text-lg tracking-wider uppercase hover:text-[#c8e04a] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-white cursor-pointer w-8 h-8 flex items-center justify-center"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#475816] border-t border-[#5a6e1a] px-4 py-4 flex flex-col gap-4">
          {[
            { label: "Lineup", id: "lineup" },
            { label: "Location", id: "location" },
            { label: "Richiesta Stand", id: "richiesta-stand" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="font-['Londrina_Solid'] text-white text-xl tracking-wider uppercase text-left hover:text-[#c8e04a] transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
